import exchangeIcon from '@raison/static/icons/arrow-left-right-line.svg';
import topupIcon from '@raison/static/icons/download-line.svg';
import withdrawIcon from '@raison/static/icons/upload-line.svg';
import React from 'react';
import {DashboardActionGroup} from '~/features/dashboard-asset-pages';

export default function HomePageActionsButtonGroup(props: {
    onReceiveClick: () => void;
    onExchangeClick: () => void;
    onSendClick: () => void;
    className?: string;
}) {
    return (
        <DashboardActionGroup
            actions={[
                {
                    onClick: props.onReceiveClick,
                    label: 'Receive',
                    icon: topupIcon,
                },
                {
                    onClick: props.onExchangeClick,
                    label: 'Trade',
                    icon: exchangeIcon,
                },
                {
                    onClick: props.onSendClick,
                    label: 'Send',
                    icon: withdrawIcon,
                },
            ]}
        />
    );
}
